<template>
  <section class="app-transporte">
    <v-container grid-list-xl>
      <v-layout row wrap>
        <v-flex lg12 sm12 xs12>
          <v-card outlined class="app-card">
            <v-card-title class="app-card-title"
              >Acessar - Transportes</v-card-title
            >
            <v-card-text class="app-card-content">
              <v-alert text type="success" outlined prominent>
                Após efetuar o login com o CNPJ/CPF e Token é possível ter
                acesso aos serviços abaixo:
                <ul>
                  <li>Extrato de Infração</li>
                  <li>Licença Especial</li>
                  <li>Notificação de Infração</li>
                  <li>Taxas Avulsas</li>
                </ul>
              </v-alert>
              <v-alert text type="info" outlined icon="error_outline" prominent>
                Caso você não tenha ou perdeu o Token, entre em contato com a
                Coordenadoria de Transportes no e-mail
                <a href="mailto:ctr@arce.ce.gov.br">ctr@arce.ce.gov.br</a>
              </v-alert>
              <v-form ref="form" lazy-validation @submit.prevent="onSubmit">
                <v-row>
                  <v-col :md="12" :sm="12" :xs="12" cols="12">
                    <v-text-field
                      v-model="formattedCnpj"
                      placeholder="Digite o CNPJ/CPF da transportadora"
                      label="CNPJ/CPF Transportadora *"
                      :rules="[rules.required, rules.documento]"
                      maxlength="18"
                      filled
                      rounded
                      dense
                    ></v-text-field>
                  </v-col>
                  <v-col :md="12" :sm="12" :xs="12" cols="12">
                    <v-text-field
                      v-model="form.token"
                      type="password"
                      placeholder="Digite o Token da transportadora"
                      label="Token *"
                      :rules="[rules.required]"
                      filled
                      rounded
                      dense
                    ></v-text-field>
                    <div class="forget-password">
                      <router-link to="resetar-token" class="text-left"
                        >Esqueceu o token?</router-link
                      >
                    </div>
                  </v-col>
                  <v-col :md="9" :sm="9" :xs="12" cols="12">
                    <vue-recaptcha
                      ref="recaptcha"
                      :sitekey="siteKey"
                      :loadRecaptchaScript="true"
                      @verify="verifyRecaptcha"
                      @expired="expiredRecaptcha"
                      class="recaptcha"
                    ></vue-recaptcha>
                    <v-input
                      v-model="form.recaptcha"
                      :rules="[rules.required]"
                    ></v-input>
                  </v-col>
                  <v-col :md="3" :sm="3" :xs="12" cols="12">
                    <v-btn depressed block large color="primary" type="submit"
                      >Continuar</v-btn
                    >
                  </v-col>

                  <v-col :md="3" :sm="3" :xs="12" cols="12"></v-col>
                </v-row>
              </v-form>
              <div class="loading" v-if="isLoading">
                <v-progress-circular
                  :size="25"
                  color="primary"
                  indeterminate
                ></v-progress-circular>
              </div>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </section>
</template>

<script>
import VueRecaptcha from "vue-recaptcha";
import { VUE_APP_RECAPTCHA_KEY } from "@/commons/config";
import TransportadoraAuthAuthService from "@/services/transportadora.auth.service";
import GlobalStore from "@/store/modules/global";
import {
  detectTipoPessoa,
  formatDocumentoInput,
  validateDocumentoInput
} from "@/helpers/documento-identificacao.helper";

export default {
  components: {
    VueRecaptcha
  },
  data() {
    return {
      siteKey: VUE_APP_RECAPTCHA_KEY,
      isLoading: false,
      form: {
        cnpj: null,
        token: null,
        recaptcha: null
      },
      rules: {
        required: value => !!value || "Esse campo deve ser preenchido",
        documento: value =>
          validateDocumentoInput(value, detectTipoPessoa(value)) ||
          "CNPJ/CPF inválido"
      }
    };
  },
  computed: {
    formattedCnpj: {
      get() {
        return this.form.cnpj;
      },
      set(value) {
        this.form.cnpj = formatDocumentoInput(value, detectTipoPessoa(value));
      }
    }
  },
  methods: {
    verifyRecaptcha(value) {
      this.form.recaptcha = value;
    },
    expiredRecaptcha() {
      this.$refs.recaptcha.reset();
      this.form.recaptcha = null;
    },
    onSubmit() {
      const isValid = this.$refs.form.validate();

      if (isValid) {
        this.isLoading = true;
        const { cnpj, token, recaptcha } = this.form;
        const { returnUrl } = this.$route.query;
        TransportadoraAuthAuthService.login(
          cnpj,
          token,
          recaptcha,
          returnUrl
        ).subscribe(
          response => {
            this.isLoading = false;
          },
          error => { 
            this.expiredRecaptcha();
            this.isLoading = false;
            const data = error?.response?.data;
            const backendMessage =
              typeof data === "string" ? data : data?.message;
            GlobalStore.setSnackBar({
              show: true,
              type: "error",
              message: backendMessage || "Erro ao efetuar login. Tente novamente."
            });
          }
        );
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.forget-password {
  margin-top: 10px !important;
  float: right;
  position: relative;
  top: -25px;
  right: 7px;
}
</style>
